import { Users } from '@orgus/ui/icons';
import { MembersView } from '../../auth/MembersView.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'members',
  title: 'Members and sign-in',
  description: 'Who can sign in, and what each person may do.',
  order: 10,
  group: 'workspace',
  keywords: ['people', 'users', 'roles', 'github', 'google', 'microsoft', 'sso', 'sign in', 'login', 'invite', 'auth', 'oauth'],
  icon: Users,
  Component: MembersView,
};
export default section;
